export const MAX_ENTRIES = 4;

export const trackedExternalLinks = [
  "https://docs.scraperapi.com",
  "https://www.scraperapi.com",
];
